<script lang="ts">
    import FormVehicle from "../FormVehicle.svelte";
    import type {IRevisionResponse} from "../../data";
    import {onMount} from "svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {getFormatter, getSelectedCity} from "../../utils";
    import {Cart, getCart} from "../../models/cart";
    import CatalogPage from "../products/CatalogPage.svelte";

    export let cities: Array<any> = [];
    export let km: number;
    let related: Array<any> = [];
    export let revision: IRevisionResponse;
    let cart: Cart;
    export let detail: IRevisionDetail;
    export let mapperService;
    let dialog = {
        open: false,
        message: ''
    };
    const formatter = getFormatter();

    let step = 1;
    let step_title = 'Información de tu vehículo';

    interface IRevisionDetail {
        id: number;
        seo_title: string;
        seo_description: string;
        kilometros: string;
        descripcion: string;
        que_se_realizara: string[];
        repuestos_incluidos: string[];
        kilometros_show: string;
    }

    const isMobile = window.innerWidth < 768;

    onMount(() => {
        getCart().then((c) => {
            cart = c;
        });
    });

    export function getDetail() {
        if (revision) {
            fetch(`/backend/api/v2/ecommerce/mantenimiento-prepagado-revision/kilometros/${revision.kmPaquete}/`, {
                method: 'GET'
            }).then((response: any) => {
                if (response.ok) {
                    response.json().then((data) => {
                        detail = data;
                        step = 2;
                        step_title = 'Tu mantenimiento';
                    });
                }
            });
        }
    }

    function getRelated() {
        const params = new URLSearchParams();
        params.append('codModeloTasa', revision.codModeloTasa);

        const url = `/backend/servicio/search-mantenimiento-preventivo-related/?${params.toString()}`;

        fetch(url, {
            method: 'GET',
        }).then((response: any) => {
            if (response.ok) {
                response.json().then((data) => {
                    related = data.related.map(i => mapperService(i, getSelectedCity(), revision.codModeloTasa));
                });
            }
        });
    }


    export function openDialog(message) {
        dialog = {
            open: true,
            message
        }
    }

    function add() {
        cart.addRevision({
            prevPrice: revision.precioTotal,
            price: revision.precioNeto,
            flag: revision?.porcDescuento > 0 ? `DCTO ${revision.porcDescuento}%` : '',
            quantity: 1,
            item: {
                id: revision.codPaquete,
                name: revision.descPaquete,
                vin: revision.vin,
                codModeloTasa: revision.codModeloTasa,
                reference: revision.codPaquete,
                km: revision.kmPaquete,
                image: '/static/storefront/pix/revision-carrito.jpeg',
                type: 'S',
                route: `/revision/${revision.kmPaquete}`
            },
            city: {
                id: getSelectedCity()
            }
        });
        cart.update().then(() => {
            dialog.message = '<p>Se ha agregado el mantenimiento preventivo al carrito</p>';
            dialog.open = true;
            getRelated();
        }).catch(() => {
            dialog.message = '<p>Se presento un error, vuelva a intentarlo.</p>';
            dialog.open = true;
        })
    }

    function updateTotal() {
        getCart().then((c) => {
            cart = c;
        });
    }


</script>
<section class="steps">
    <div class="container py-1">
        <div class="box mb-1">
            {#if step === 1}
                <img height="30" src="/static/storefront/pix/icons/paso-1.svg" alt="paso 1">
            {:else if step === 2}
                <img height="30" src="/static/storefront/pix/icons/paso-2.svg" alt="paso 2">
            {:else if step === 3}
                <img height="30" src="/static/storefront/pix/icons/paso-3.svg" alt="paso 3">
            {/if}
        </div>
        <h3 class="text-c">{step_title}</h3>
    </div>
</section>

{#if step === 1}
    <FormVehicle title="Tu revisión de mantenimiento preventivo"
                 text="Ingresa la información de tu vehículo para ver el plan indicado para ti"
                 button="Encuentra la revisión para tu Nissan"
                 {km}
                 {cities}
                 on:search/>
{:else if step === 2 && revision}
    {#if isMobile}
        <div class="py-2" style="display: flex; flex-direction: column;">
            <div>
                <h3 class="mb-15">Revision de mantenimiento de {revision.kilometraje} Km para tu
                    Nissan {revision.placa}</h3>
                <div class="formatted">El precio aquí presentado incluye la mano de obra y repuestos necesarios para su
                    revisión de mantenimiento. En su visita al taller puede haber operaciones o repuestos adicionales
                    detectados
                    durante la revisión. Estos adicionales solo se realizarán con su previa autorización.
                </div>
            </div>
        </div>
    {:else}
        <div class="py-2" style="display: flex;">
            <div class="" style="float: left">
                <h2 class="mb-15">Revision de mantenimiento de {revision.kilometraje} Km para tu
                    Nissan {revision.placa}</h2>
                <div class="formatted">El precio aquí presentado incluye la mano de obra y repuestos necesarios para su
                    revisión de mantenimiento. En su visita al taller puede haber operaciones o repuestos adicionales
                    detectados
                    durante la revisión. Estos adicionales solo se realizarán con su previa autorización.
                </div>
            </div>
            <div class="text-c m:text-l px-2" style="float: left;">
                {#if revision.porcDescuento > 0}
                    <small>Antes {formatter(revision.precioTotal)}</small>
                {/if}
                <div class="price">
                    {formatter(revision.precioNeto)}
                </div>
                <div class="btn accent" on:click={()=>add()}>
                    AGREGAR
                </div>
            </div>
        </div>
    {/if}
    {#if detail}
        <div class="max-w-900px mb-1">
            <div class="accordion"
                 class:active={detail.que_se_realizara_toggle}>
                <div class="accordion-header box-b border-bottom py-iii"
                     on:click={()=>(detail.que_se_realizara_toggle=!detail.que_se_realizara_toggle)}>
                    <div>
                        <strong style="font-size: 14px">Qué se realizará</strong>
                    </div>
                    <div>
                        <img class="chevron" height="20" src="/static/storefront/pix/icons/chevron-gray.svg"
                             alt="chevron">
                    </div>
                </div>
                <div class="accordion-panel py-1">
                    {#each detail.que_se_realizara as item}
                        <div class="p-ii">
                            {item}
                        </div>
                    {/each}
                </div>
            </div>
        </div>
        <div class="max-w-900px mb-2">
            <div class="accordion"
                 class:active={detail.repuestos_incluidos_active}>
                <div class="accordion-header box-b border-bottom py-iii"
                     on:click={()=>(detail.repuestos_incluidos_active=!detail.repuestos_incluidos_active)}>
                    <div>
                        <strong style="font-size: 14px">Repuestos Incluidos</strong>
                    </div>
                    <div>
                        <img class="chevron" height="20" src="/static/storefront/pix/icons/chevron-gray.svg"
                             alt="chevron">
                    </div>
                </div>
                <div class="accordion-panel py-1">
                    {#each detail.repuestos_incluidos as item}
                        <div class="p-ii">
                            {item}
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    {/if}
    <div class="py-ii footer-total">
        <h1 class="ml-2" style="float: left; font-weight: bolder">TOTAL</h1>
        <div class="text-c m:text-l px-2" style="float: right;">
            {#if revision.porcDescuento > 0}
                <small>Antes {formatter(revision.precioTotal)}</small>
            {/if}
            <div class="price">
                {formatter(revision.precioNeto)}
            </div>
            <div class="btn accent" on:click={()=>add()}>
                AGREGAR
            </div>
        </div>
    </div>
{:else if step === 3}
    <section class="py-2">
        <div class="container">
            <div class="box p-1">
                <img class="mr-ii hidden s:block" height="24"
                     src="/static/storefront/pix/material/check_circle.svg">
                <img class="mr-ii hidden mobile-icon" height="16"
                     src="/static/storefront/pix/material/check_circle.svg">
                <h4 style="color: #06741B;">El mantenimiento de <b>{revision.kilometraje}</b> Km para tu
                    Nissan <b>{revision.placa}</b> ha sido agregado al carrito</h4>
            </div>
            <div class="mt-1">
                {#if related.length > 0}
                    <CatalogPage title="También te puede interesar"
                                 data={related}
                                 showViewMore={false}
                                 {cart}
                                 on:updateTotal={updateTotal}/>
                {:else}
                    <div class="text-c">
                        <h2 class="mb-15">No hay productos relacionados</h2>
                    </div>
                {/if}
            </div>
        </div>
        <div class="py-ii footer-total">
            <h1 class="ml-2" style="float: left; font-weight: bolder">TOTAL</h1>
            <div class="text-c m:text-l px-2" style="float: right;">
                <div class="price">
                    {formatter(cart?.total)}
                </div>
                <div class="btn accent" on:click={() => {
                    location.href = "/checkout/carrito";
                }}>
                    CONTINUAR
                </div>
            </div>
        </div>
    </section>

{/if}


<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-1 w-100">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={() => {
                            dialog.open = false;
                            step = 3;
                            step_title = 'Servicios adicionales';
                        }}/>
        </div>
    </Actions>
</Dialog>

<style>
    .steps {
        background: url('/static/storefront/pix/menu-fondo-whatsapp.jpg');
        background-size: cover;
    }

    .footer-total {
        display: flex;
        justify-content: space-between;
        background-color: #DDDFDE;
        align-items: center;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-right: 80px;
    }
</style>